module.exports = __webpack_public_path__ + "static/img/weight.685bba7a.png";